'use strict';

var _defineProperty = require("/home/jenkins/workspace/GBS_GBS_Release-3.43.12/app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _toConsumableArray = require("/home/jenkins/workspace/GBS_GBS_Release-3.43.12/app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _possibleConstructorReturn = require("/home/jenkins/workspace/GBS_GBS_Release-3.43.12/app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/jenkins/workspace/GBS_GBS_Release-3.43.12/app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/jenkins/workspace/GBS_GBS_Release-3.43.12/app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/home/jenkins/workspace/GBS_GBS_Release-3.43.12/app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _classCallCheck = require("/home/jenkins/workspace/GBS_GBS_Release-3.43.12/app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/jenkins/workspace/GBS_GBS_Release-3.43.12/app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var _extends = _interopDefault(require('@babel/runtime/helpers/esm/extends'));
var _objectWithoutPropertiesLoose = _interopDefault(require('@babel/runtime/helpers/esm/objectWithoutPropertiesLoose'));
var React = require('react');
var React__default = _interopDefault(React);
var bugfixes = undefined;
var applyAnimatedValues = undefined;
var colorNames = [];
var requestFrame = function requestFrame(cb) {
  return typeof window !== 'undefined' && window.requestAnimationFrame(cb);
};
var cancelFrame = function cancelFrame(cb) {
  return typeof window !== 'undefined' && window.cancelAnimationFrame(cb);
};
var interpolation = undefined;
var now = function now() {
  return Date.now();
};
var defaultElement = undefined;
var createAnimatedStyle = undefined;
var injectApplyAnimatedValues = function injectApplyAnimatedValues(fn, transform) {
  return applyAnimatedValues = {
    fn: fn,
    transform: transform
  };
};
var injectColorNames = function injectColorNames(names) {
  return colorNames = names;
};
var injectBugfixes = function injectBugfixes(fn) {
  return bugfixes = fn;
};
var injectInterpolation = function injectInterpolation(cls) {
  return interpolation = cls;
};
var injectFrame = function injectFrame(raf, caf) {
  var _ref = [raf, caf];
  requestFrame = _ref[0];
  cancelFrame = _ref[1];
  return _ref;
};
var injectNow = function injectNow(nowFn) {
  return now = nowFn;
};
var injectDefaultElement = function injectDefaultElement(el) {
  return defaultElement = el;
};
var injectCreateAnimatedStyle = function injectCreateAnimatedStyle(factory) {
  return createAnimatedStyle = factory;
};
var Globals = /*#__PURE__*/Object.freeze({
  get bugfixes() {
    return bugfixes;
  },
  get applyAnimatedValues() {
    return applyAnimatedValues;
  },
  get colorNames() {
    return colorNames;
  },
  get requestFrame() {
    return requestFrame;
  },
  get cancelFrame() {
    return cancelFrame;
  },
  get interpolation() {
    return interpolation;
  },
  get now() {
    return now;
  },
  get defaultElement() {
    return defaultElement;
  },
  get createAnimatedStyle() {
    return createAnimatedStyle;
  },
  injectApplyAnimatedValues: injectApplyAnimatedValues,
  injectColorNames: injectColorNames,
  injectBugfixes: injectBugfixes,
  injectInterpolation: injectInterpolation,
  injectFrame: injectFrame,
  injectNow: injectNow,
  injectDefaultElement: injectDefaultElement,
  injectCreateAnimatedStyle: injectCreateAnimatedStyle
});
var Animated = /*#__PURE__*/function () {
  function Animated() {
    _classCallCheck(this, Animated);
  }
  _createClass(Animated, [{
    key: "attach",
    value: function attach() {}
  }, {
    key: "detach",
    value: function detach() {}
  }, {
    key: "getValue",
    value: function getValue() {}
  }, {
    key: "getAnimatedValue",
    value: function getAnimatedValue() {
      return this.getValue();
    }
  }, {
    key: "addChild",
    value: function addChild(child) {}
  }, {
    key: "removeChild",
    value: function removeChild(child) {}
  }, {
    key: "getChildren",
    value: function getChildren() {
      return [];
    }
  }]);
  return Animated;
}();
var getValues = function getValues(object) {
  return Object.keys(object).map(function (k) {
    return object[k];
  });
};
var AnimatedWithChildren = /*#__PURE__*/function (_Animated) {
  _inherits(AnimatedWithChildren, _Animated);
  function AnimatedWithChildren() {
    var _this3;
    _classCallCheck(this, AnimatedWithChildren);
    var _this;
    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(AnimatedWithChildren).apply(this, arguments));
    _this = _assertThisInitialized(_assertThisInitialized(_this3));
    _this3.children = [];
    _this3.getChildren = function () {
      return _this3.children;
    };
    _this3.getPayload = function (index) {
      if (index === void 0) {
        index = undefined;
      }
      return index !== void 0 && _this.payload ? _this.payload[index] : _this.payload || _this;
    };
    return _this3;
  }
  _createClass(AnimatedWithChildren, [{
    key: "addChild",
    value: function addChild(child) {
      if (this.children.length === 0) this.attach();
      this.children.push(child);
    }
  }, {
    key: "removeChild",
    value: function removeChild(child) {
      var index = this.children.indexOf(child);
      this.children.splice(index, 1);
      if (this.children.length === 0) this.detach();
    }
  }]);
  return AnimatedWithChildren;
}(Animated);
var AnimatedArrayWithChildren = /*#__PURE__*/function (_AnimatedWithChildren) {
  _inherits(AnimatedArrayWithChildren, _AnimatedWithChildren);
  function AnimatedArrayWithChildren() {
    var _this4;
    _classCallCheck(this, AnimatedArrayWithChildren);
    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(AnimatedArrayWithChildren).apply(this, arguments));
    _this4.payload = [];
    _this4.getAnimatedValue = function () {
      return _this4.getValue();
    };
    _this4.attach = function () {
      return _this4.payload.forEach(function (p) {
        return p instanceof Animated && p.addChild(_assertThisInitialized(_assertThisInitialized(_this4)));
      });
    };
    _this4.detach = function () {
      return _this4.payload.forEach(function (p) {
        return p instanceof Animated && p.removeChild(_assertThisInitialized(_assertThisInitialized(_this4)));
      });
    };
    return _this4;
  }
  return AnimatedArrayWithChildren;
}(AnimatedWithChildren);
var AnimatedObjectWithChildren = /*#__PURE__*/function (_AnimatedWithChildren2) {
  _inherits(AnimatedObjectWithChildren, _AnimatedWithChildren2);
  function AnimatedObjectWithChildren() {
    var _this5;
    _classCallCheck(this, AnimatedObjectWithChildren);
    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(AnimatedObjectWithChildren).apply(this, arguments));
    _this5.payload = {};
    _this5.getAnimatedValue = function () {
      return _this5.getValue(true);
    };
    _this5.attach = function () {
      return getValues(_this5.payload).forEach(function (s) {
        return s instanceof Animated && s.addChild(_assertThisInitialized(_assertThisInitialized(_this5)));
      });
    };
    _this5.detach = function () {
      return getValues(_this5.payload).forEach(function (s) {
        return s instanceof Animated && s.removeChild(_assertThisInitialized(_assertThisInitialized(_this5)));
      });
    };
    return _this5;
  }
  _createClass(AnimatedObjectWithChildren, [{
    key: "getValue",
    value: function getValue(animated) {
      if (animated === void 0) {
        animated = false;
      }
      var payload = {};
      for (var key in this.payload) {
        var value = this.payload[key];
        if (animated && !(value instanceof Animated)) continue;
        payload[key] = value instanceof Animated ? value[animated ? 'getAnimatedValue' : 'getValue']() : value;
      }
      return payload;
    }
  }]);
  return AnimatedObjectWithChildren;
}(AnimatedWithChildren);
var Interpolation = /*#__PURE__*/function () {
  function Interpolation() {
    _classCallCheck(this, Interpolation);
  }
  _createClass(Interpolation, null, [{
    key: "create",
    // Default config = config, args
    // Short config   = range, output, extrapolate
    value: function create(config, output, extra) {
      if (typeof config === 'function') return config;else if (interpolation && config.output && typeof config.output[0] === 'string') return interpolation(config);else if (Array.isArray(config)) return Interpolation.create({
        range: config,
        output: output,
        extrapolate: extra || 'extend'
      });
      var outputRange = config.output;
      var inputRange = config.range || [0, 1];
      var easing = config.easing || function (t) {
        return t;
      };
      var extrapolateLeft = 'extend';
      var map = config.map;
      if (config.extrapolateLeft !== undefined) extrapolateLeft = config.extrapolateLeft;else if (config.extrapolate !== undefined) extrapolateLeft = config.extrapolate;
      var extrapolateRight = 'extend';
      if (config.extrapolateRight !== undefined) extrapolateRight = config.extrapolateRight;else if (config.extrapolate !== undefined) extrapolateRight = config.extrapolate;
      return function (input) {
        var range = findRange(input, inputRange);
        return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, map);
      };
    }
  }]);
  return Interpolation;
}();
function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  var result = map ? map(input) : input; // Extrapolate

  if (result < inputMin) {
    if (extrapolateLeft === 'identity') return result;else if (extrapolateLeft === 'clamp') result = inputMin;
  }
  if (result > inputMax) {
    if (extrapolateRight === 'identity') return result;else if (extrapolateRight === 'clamp') result = inputMax;
  }
  if (outputMin === outputMax) return outputMin;
  if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax; // Input Range

  if (inputMin === -Infinity) result = -result;else if (inputMax === Infinity) result = result - inputMin;else result = (result - inputMin) / (inputMax - inputMin); // Easing

  result = easing(result); // Output Range

  if (outputMin === -Infinity) result = -result;else if (outputMax === Infinity) result = result + outputMin;else result = result * (outputMax - outputMin) + outputMin;
  return result;
}
function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i) if (inputRange[i] >= input) break;
  return i - 1;
}
var AnimatedInterpolation = /*#__PURE__*/function (_AnimatedArrayWithChi) {
  _inherits(AnimatedInterpolation, _AnimatedArrayWithChi);
  function AnimatedInterpolation(parents, _config, _arg) {
    var _this6;
    _classCallCheck(this, AnimatedInterpolation);
    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(AnimatedInterpolation).call(this));
    _this6.getValue = function () {
      var _this7;
      return (_this7 = _this6).calc.apply(_this7, _toConsumableArray(_this6.payload.map(function (value) {
        return value.getValue();
      })));
    };
    _this6.updateConfig = function (config, arg) {
      return _this6.calc = Interpolation.create(config, arg);
    };
    _this6.interpolate = function (config, arg) {
      return new AnimatedInterpolation(_assertThisInitialized(_assertThisInitialized(_this6)), config, arg);
    };
    _this6.payload =
    // AnimatedArrays should unfold, except AnimatedInterpolation which is taken as is
    parents instanceof AnimatedArrayWithChildren && !parents.updateConfig ? parents.payload : Array.isArray(parents) ? parents : [parents];
    _this6.calc = Interpolation.create(_config, _arg);
    return _this6;
  }
  return AnimatedInterpolation;
}(AnimatedArrayWithChildren);
var interpolate$1 = function interpolate$1(parents, config, arg) {
  return parents && new AnimatedInterpolation(parents, config, arg);
};

/**
 * Animated works by building a directed acyclic graph of dependencies
 * transparently when you render your Animated components.
 *
 *               new Animated.Value(0)
 *     .interpolate()        .interpolate()    new Animated.Value(1)
 *         opacity               translateY      scale
 *          style                         transform
 *         View#234                         style
 *                                         View#123
 *
 * A) Top Down phase
 * When an Animated.Value is updated, we recursively go down through this
 * graph in order to find leaf nodes: the views that we flag as needing
 * an update.
 *
 * B) Bottom Up phase
 * When a view is flagged as needing an update, we recursively go back up
 * in order to build the new value that it needs. The reason why we need
 * this two-phases process is to deal with composite props such as
 * transform which can receive values from multiple parents.
 */

function findAnimatedStyles(node, styles) {
  if (typeof node.update === 'function') styles.add(node);else node.getChildren().forEach(function (child) {
    return findAnimatedStyles(child, styles);
  });
}
/**
 * Standard value for driving animations.  One `Animated.Value` can drive
 * multiple properties in a synchronized fashion, but can only be driven by one
 * mechanism at a time.  Using a new mechanism (e.g. starting a new animation,
 * or calling `setValue`) will stop any previous ones.
 */
var AnimatedValue = /*#__PURE__*/function (_AnimatedWithChildren3) {
  _inherits(AnimatedValue, _AnimatedWithChildren3);
  function AnimatedValue(_value) {
    var _this8;
    _classCallCheck(this, AnimatedValue);
    var _this;
    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(AnimatedValue).call(this));
    _this = _assertThisInitialized(_assertThisInitialized(_this8));
    _this8.setValue = function (value, flush) {
      if (flush === void 0) {
        flush = true;
      }
      _this.value = value;
      if (flush) _this.flush();
    };
    _this8.getValue = function () {
      return _this8.value;
    };
    _this8.updateStyles = function () {
      return findAnimatedStyles(_assertThisInitialized(_assertThisInitialized(_this8)), _this8.animatedStyles);
    };
    _this8.updateValue = function (value) {
      return _this8.flush(_this8.value = value);
    };
    _this8.interpolate = function (config, arg) {
      return new AnimatedInterpolation(_assertThisInitialized(_assertThisInitialized(_this8)), config, arg);
    };
    _this8.value = _value;
    _this8.animatedStyles = new Set();
    _this8.done = false;
    _this8.startPosition = _value;
    _this8.lastPosition = _value;
    _this8.lastVelocity = undefined;
    _this8.lastTime = undefined;
    _this8.controller = undefined;
    return _this8;
  }
  _createClass(AnimatedValue, [{
    key: "flush",
    value: function flush() {
      if (this.animatedStyles.size === 0) this.updateStyles();
      this.animatedStyles.forEach(function (animatedStyle) {
        return animatedStyle.update();
      });
    }
  }, {
    key: "prepare",
    value: function prepare(controller) {
      // Values stay loyal to their original controller, this is also a way to
      // detect trailing values originating from a foreign controller
      if (this.controller === undefined) this.controller = controller;
      if (this.controller === controller) {
        this.startPosition = this.value;
        this.lastPosition = this.value;
        this.lastVelocity = controller.isActive ? this.lastVelocity : undefined;
        this.lastTime = controller.isActive ? this.lastTime : undefined;
        this.done = false;
        this.animatedStyles.clear();
      }
    }
  }]);
  return AnimatedValue;
}(AnimatedWithChildren);
var AnimatedArray = /*#__PURE__*/function (_AnimatedArrayWithChi2) {
  _inherits(AnimatedArray, _AnimatedArrayWithChi2);
  function AnimatedArray(array) {
    var _this9;
    _classCallCheck(this, AnimatedArray);
    var _this;
    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(AnimatedArray).call(this));
    _this = _assertThisInitialized(_assertThisInitialized(_this9));
    _this9.setValue = function (value, flush) {
      if (flush === void 0) {
        flush = true;
      }
      if (Array.isArray(value)) {
        if (value.length === _this.payload.length) value.forEach(function (v, i) {
          return _this.payload[i].setValue(v, flush);
        });
      } else _this.payload.forEach(function (v, i) {
        return _this.payload[i].setValue(value, flush);
      });
    };
    _this9.getValue = function () {
      return _this9.payload.map(function (v) {
        return v.getValue();
      });
    };
    _this9.interpolate = function (config, arg) {
      return new AnimatedInterpolation(_assertThisInitialized(_assertThisInitialized(_this9)), config, arg);
    };
    _this9.payload = array.map(function (n) {
      return new AnimatedValue(n);
    });
    return _this9;
  }
  return AnimatedArray;
}(AnimatedArrayWithChildren);
var active = false;
var controllers = new Set();
var frameLoop = function frameLoop() {
  var time = now();
  var _iterator = _createForOfIteratorHelper(controllers),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var controller = _step.value;
      var isDone = true;
      var noChange = true;
      for (var configIdx = 0; configIdx < controller.configs.length; configIdx++) {
        var _config2 = controller.configs[configIdx];
        var endOfAnimation = void 0,
          lastTime = void 0;
        for (var valIdx = 0; valIdx < _config2.animatedValues.length; valIdx++) {
          var animation = _config2.animatedValues[valIdx]; // If an animation is done, skip, until all of them conclude

          if (animation.done) continue;
          var from = _config2.fromValues[valIdx];
          var to = _config2.toValues[valIdx];
          var position = animation.lastPosition;
          var isAnimated = to instanceof Animated;
          var velocity = Array.isArray(_config2.initialVelocity) ? _config2.initialVelocity[valIdx] : _config2.initialVelocity;
          if (isAnimated) to = to.getValue(); // Conclude animation if it's either immediate, or from-values match end-state

          if (_config2.immediate || !isAnimated && !_config2.decay && from === to) {
            animation.updateValue(to);
            animation.done = true;
            continue;
          } // Doing delay here instead of setTimeout is one async worry less

          if (_config2.delay && time - controller.startTime < _config2.delay) {
            isDone = false;
            continue;
          } // Flag change

          noChange = false; // Break animation when string values are involved

          if (typeof from === 'string' || typeof to === 'string') {
            animation.updateValue(to);
            animation.done = true;
            continue;
          }
          if (_config2.duration !== void 0) {
            /** Duration easing */
            position = from + _config2.easing((time - controller.startTime - _config2.delay) / _config2.duration) * (to - from);
            endOfAnimation = time >= controller.startTime + _config2.delay + _config2.duration;
          } else if (_config2.decay) {
            /** Decay easing */
            position = from + velocity / (1 - 0.998) * (1 - Math.exp(-(1 - 0.998) * (time - controller.startTime)));
            endOfAnimation = Math.abs(animation.lastPosition - position) < 0.1;
            if (endOfAnimation) to = position;
          } else {
            /** Spring easing */
            lastTime = animation.lastTime !== void 0 ? animation.lastTime : time;
            velocity = animation.lastVelocity !== void 0 ? animation.lastVelocity : _config2.initialVelocity; // If we lost a lot of frames just jump to the end.

            if (time > lastTime + 64) lastTime = time; // http://gafferongames.com/game-physics/fix-your-timestep/

            var numSteps = Math.floor(time - lastTime);
            for (var i = 0; i < numSteps; ++i) {
              var force = -_config2.tension * (position - to);
              var damping = -_config2.friction * velocity;
              var acceleration = (force + damping) / _config2.mass;
              velocity = velocity + acceleration * 1 / 1000;
              position = position + velocity * 1 / 1000;
            } // Conditions for stopping the spring animation

            var isOvershooting = _config2.clamp && _config2.tension !== 0 ? from < to ? position > to : position < to : false;
            var isVelocity = Math.abs(velocity) <= _config2.precision;
            var isDisplacement = _config2.tension !== 0 ? Math.abs(to - position) <= _config2.precision : true;
            endOfAnimation = isOvershooting || isVelocity && isDisplacement;
            animation.lastVelocity = velocity;
            animation.lastTime = time;
          } // Trails aren't done until their parents conclude

          if (isAnimated && !_config2.toValues[valIdx].done) endOfAnimation = false;
          if (endOfAnimation) {
            // Ensure that we end up with a round value
            if (animation.value !== to) position = to;
            animation.done = true;
          } else isDone = false;
          animation.updateValue(position);
          animation.lastPosition = position;
        } // Keep track of updated values only when necessary

        if (controller.props.onFrame || !controller.props.native) controller.animatedProps[_config2.name] = _config2.interpolation.getValue();
      } // Update callbacks in the end of the frame

      if (controller.props.onFrame || !controller.props.native) {
        if (!controller.props.native && controller.onUpdate) controller.onUpdate();
        if (controller.props.onFrame) controller.props.onFrame(controller.animatedProps);
      } // Either call onEnd or next frame

      if (isDone) {
        controllers.delete(controller);
        controller.debouncedOnEnd({
          finished: true,
          noChange: noChange
        });
      }
    } // Loop over as long as there are controllers ...
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (controllers.size) requestFrame(frameLoop);else active = false;
};
var addController = function addController(controller) {
  if (!controllers.has(controller)) {
    controllers.add(controller);
    if (!active) requestFrame(frameLoop);
    active = true;
  }
};
var removeController = function removeController(controller) {
  if (controllers.has(controller)) {
    controllers.delete(controller);
  }
};
function withDefault(value, defaultValue) {
  return value === undefined || value === null ? defaultValue : value;
}
function toArray(a) {
  return a !== void 0 ? Array.isArray(a) ? a : [a] : [];
}
function shallowEqual(a, b) {
  if (typeof a !== typeof b) return false;
  if (typeof a === 'string' || typeof a === 'number') return a === b;
  var i;
  for (i in a) if (!(i in b)) return false;
  for (i in b) if (a[i] !== b[i]) return false;
  return i === void 0 ? a === b : true;
}
function callProp(obj) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return typeof obj === 'function' ? obj.apply(void 0, args) : obj;
}
function getValues$1(object) {
  return Object.keys(object).map(function (k) {
    return object[k];
  });
}
function getForwardProps(props) {
  var to = props.to,
    from = props.from,
    config = props.config,
    native = props.native,
    onStart = props.onStart,
    onRest = props.onRest,
    onFrame = props.onFrame,
    children = props.children,
    reset = props.reset,
    reverse = props.reverse,
    force = props.force,
    immediate = props.immediate,
    impl = props.impl,
    inject = props.inject,
    delay = props.delay,
    attach = props.attach,
    destroyed = props.destroyed,
    interpolateTo = props.interpolateTo,
    autoStart = props.autoStart,
    ref = props.ref,
    forward = _objectWithoutPropertiesLoose(props, ["to", "from", "config", "native", "onStart", "onRest", "onFrame", "children", "reset", "reverse", "force", "immediate", "impl", "inject", "delay", "attach", "destroyed", "interpolateTo", "autoStart", "ref"]);
  return forward;
}
function interpolateTo(props) {
  var forward = getForwardProps(props);
  var rest = Object.keys(props).reduce(function (a, k) {
    return forward[k] !== void 0 ? a : _extends({}, a, _defineProperty({}, k, props[k]));
  }, {});
  return _extends({
    to: forward
  }, rest);
}
function convertToAnimatedValue(acc, _ref) {
  var name = _ref[0],
    value = _ref[1];
  return _extends({}, acc, _defineProperty({}, name, new (Array.isArray(value) ? AnimatedArray : AnimatedValue)(value)));
}
function convertValues(props) {
  var from = props.from,
    to = props.to,
    native = props.native;
  var allProps = Object.entries(_extends({}, from, to));
  return native ? allProps.reduce(convertToAnimatedValue, {}) : _extends({}, from, to);
}
function handleRef(ref, forward) {
  if (forward) {
    // If it's a function, assume it's a ref callback
    if (typeof forward === 'function') forward(ref);else if (typeof forward === 'object') {
      // If it's an object and has a 'current' property, assume it's a ref object
      forward.current = ref;
    }
  }
  return ref;
}
var Controller = /*#__PURE__*/function () {
  function Controller(props, config) {
    var _this10 = this;
    _classCallCheck(this, Controller);
    if (config === void 0) {
      config = {
        native: true,
        interpolateTo: true,
        autoStart: true
      };
    }
    this.getValues = function () {
      return _this10.props.native ? _this10.interpolations : _this10.animatedProps;
    };
    this.dependents = new Set();
    this.isActive = false;
    this.hasChanged = false;
    this.props = {};
    this.merged = {};
    this.animations = {};
    this.interpolations = {};
    this.animatedProps = {};
    this.configs = [];
    this.frame = undefined;
    this.startTime = undefined;
    this.lastTime = undefined;
    this.update(_extends({}, props, config));
  }
  _createClass(Controller, [{
    key: "update",
    value: function update(props) {
      var _this11 = this;
      this.props = _extends({}, this.props, props);
      var _ref = this.props.interpolateTo ? interpolateTo(this.props) : this.props,
        _ref$from = _ref.from,
        from = _ref$from === void 0 ? {} : _ref$from,
        _ref$to = _ref.to,
        to = _ref$to === void 0 ? {} : _ref$to,
        _ref$config = _ref.config,
        config = _ref$config === void 0 ? {} : _ref$config,
        _ref$delay = _ref.delay,
        delay = _ref$delay === void 0 ? 0 : _ref$delay,
        reverse = _ref.reverse,
        attach = _ref.attach,
        reset = _ref.reset,
        immediate = _ref.immediate,
        autoStart = _ref.autoStart,
        ref = _ref.ref; // Reverse values when requested

      if (reverse) {
        var _ref2 = [to, from];
        from = _ref2[0];
        to = _ref2[1];
      }
      this.hasChanged = false; // Attachment handling, trailed springs can "attach" themselves to a previous spring

      var target = attach && attach(this); // Reset merged props when necessary

      var extra = reset ? {} : this.merged; // This will collect all props that were ever set

      this.merged = _extends({}, from, extra, to); // Reduces input { name: value } pairs into animated values

      this.animations = Object.entries(this.merged).reduce(function (acc, _ref3, i) {
        var name = _ref3[0],
          value = _ref3[1];
        // Issue cached entries, except on reset
        var entry = !reset && acc[name] || {}; // Figure out what the value is supposed to be

        var isNumber = typeof value === 'number';
        var isString = typeof value === 'string' && !value.startsWith('#') && !/\d/.test(value) && !colorNames[value];
        var isArray = !isNumber && !isString && Array.isArray(value);
        var fromValue = from[name] !== undefined ? from[name] : value;
        var toValue = isNumber || isArray ? value : isString ? value : 1;
        var toConfig = callProp(config, name);
        if (target) toValue = target.animations[name].parent; // Detect changes, animated values will be checked in the raf-loop

        if (toConfig.decay !== void 0 || !shallowEqual(entry.changes, value)) {
          _this11.hasChanged = true;
          var parent, interpolation$$1;
          if (isNumber || isString) parent = interpolation$$1 = entry.parent || new AnimatedValue(fromValue);else if (isArray) parent = interpolation$$1 = entry.parent || new AnimatedArray(fromValue);else {
            var prev = entry.interpolation && entry.interpolation.calc(entry.parent.value);
            if (entry.parent) {
              parent = entry.parent;
              parent.setValue(0, false);
            } else parent = new AnimatedValue(0);
            var range = {
              output: [prev !== void 0 ? prev : fromValue, value]
            };
            if (entry.interpolation) {
              interpolation$$1 = entry.interpolation;
              entry.interpolation.updateConfig(range);
            } else interpolation$$1 = parent.interpolate(range);
          } // Set immediate values

          if (callProp(immediate, name)) parent.setValue(value, false); // Reset animated values

          var animatedValues = toArray(parent.getPayload());
          animatedValues.forEach(function (value) {
            return value.prepare(_this11);
          });
          return _extends({}, acc, _defineProperty({}, name, _extends({}, entry, {
            name: name,
            parent: parent,
            interpolation: interpolation$$1,
            animatedValues: animatedValues,
            changes: value,
            fromValues: toArray(parent.getValue()),
            toValues: toArray(target ? toValue.getPayload() : toValue),
            immediate: callProp(immediate, name),
            delay: withDefault(toConfig.delay, delay || 0),
            initialVelocity: withDefault(toConfig.velocity, 0),
            clamp: withDefault(toConfig.clamp, false),
            precision: withDefault(toConfig.precision, 0.01),
            tension: withDefault(toConfig.tension, 170),
            friction: withDefault(toConfig.friction, 26),
            mass: withDefault(toConfig.mass, 1),
            duration: toConfig.duration,
            easing: withDefault(toConfig.easing, function (t) {
              return t;
            }),
            decay: toConfig.decay
          })));
        } else return acc;
      }, this.animations);
      if (this.hasChanged) {
        this.configs = getValues$1(this.animations);
        this.animatedProps = {};
        this.interpolations = {};
        for (var key in this.animations) {
          this.interpolations[key] = this.animations[key].interpolation;
          this.animatedProps[key] = this.animations[key].interpolation.getValue();
        }
      } // TODO: clean up ref in controller

      for (var _len = arguments.length, start = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        start[_key - 1] = arguments[_key];
      }
      if (!ref && (autoStart || start.length)) this.start.apply(this, start);
      var onEnd = start[0],
        onUpdate = start[1];
      this.onEnd = typeof onEnd === 'function' && onEnd;
      this.onUpdate = onUpdate;
      return this.getValues();
    }
  }, {
    key: "start",
    value: function start(onEnd, onUpdate) {
      var _this12 = this;
      this.startTime = now();
      if (this.isActive) this.stop();
      this.isActive = true;
      this.onEnd = typeof onEnd === 'function' && onEnd;
      this.onUpdate = onUpdate;
      if (this.props.onStart) this.props.onStart();
      addController(this);
      return new Promise(function (res) {
        return _this12.resolve = res;
      });
    }
  }, {
    key: "stop",
    value: function stop(finished) {
      if (finished === void 0) {
        finished = false;
      }

      // Reset collected changes since the animation has been stopped cold turkey
      if (finished) getValues$1(this.animations).forEach(function (a) {
        return a.changes = undefined;
      });
      this.debouncedOnEnd({
        finished: finished
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      removeController(this);
      this.props = {};
      this.merged = {};
      this.animations = {};
      this.interpolations = {};
      this.animatedProps = {};
      this.configs = [];
    }
  }, {
    key: "debouncedOnEnd",
    value: function debouncedOnEnd(result) {
      removeController(this);
      this.isActive = false;
      var onEnd = this.onEnd;
      this.onEnd = null;
      if (onEnd) onEnd(result);
      if (this.resolve) this.resolve();
      this.resolve = null;
    }
  }]);
  return Controller;
}();
var AnimatedProps = /*#__PURE__*/function (_AnimatedObjectWithCh) {
  _inherits(AnimatedProps, _AnimatedObjectWithCh);
  function AnimatedProps(props, callback) {
    var _this13;
    _classCallCheck(this, AnimatedProps);
    _this13 = _possibleConstructorReturn(this, _getPrototypeOf(AnimatedProps).call(this));
    if (props.style) props = _extends({}, props, {
      style: createAnimatedStyle(props.style)
    });
    _this13.payload = props;
    _this13.update = callback;
    _this13.attach();
    return _this13;
  }
  return AnimatedProps;
}(AnimatedObjectWithChildren);
function createAnimatedComponent(Component) {
  var AnimatedComponent = /*#__PURE__*/function (_React__default$Compo) {
    _inherits(AnimatedComponent, _React__default$Compo);
    function AnimatedComponent(props) {
      var _this14;
      _classCallCheck(this, AnimatedComponent);
      _this14 = _possibleConstructorReturn(this, _getPrototypeOf(AnimatedComponent).call(this));
      _this14.callback = function () {
        if (_this14.node) {
          var didUpdate = applyAnimatedValues.fn(_this14.node, _this14.propsAnimated.getAnimatedValue(), _assertThisInitialized(_assertThisInitialized(_this14)));
          if (didUpdate === false) _this14.forceUpdate();
        }
      };
      _this14.attachProps(props);
      return _this14;
    }
    _createClass(AnimatedComponent, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.propsAnimated && this.propsAnimated.detach();
      }
    }, {
      key: "setNativeProps",
      value: function setNativeProps(props) {
        var didUpdate = applyAnimatedValues.fn(this.node, props, this);
        if (didUpdate === false) this.forceUpdate();
      } // The system is best designed when setNativeProps is implemented. It is
      // able to avoid re-rendering and directly set the attributes that
      // changed. However, setNativeProps can only be implemented on leaf
      // native components. If you want to animate a composite component, you
      // need to re-render it. In this case, we have a fallback that uses
      // forceUpdate.
    }, {
      key: "attachProps",
      value: function attachProps(_ref) {
        var forwardRef = _ref.forwardRef,
          nextProps = _objectWithoutPropertiesLoose(_ref, ["forwardRef"]);
        var oldPropsAnimated = this.propsAnimated;
        this.propsAnimated = new AnimatedProps(nextProps, this.callback); // When you call detach, it removes the element from the parent list
        // of children. If it goes to 0, then the parent also detaches itself
        // and so on.
        // An optimization is to attach the new elements and THEN detach the old
        // ones instead of detaching and THEN attaching.
        // This way the intermediate state isn't to go to 0 and trigger
        // this expensive recursive detaching to then re-attach everything on
        // the very next operation.

        oldPropsAnimated && oldPropsAnimated.detach();
      }
    }, {
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(props) {
        var style = props.style,
          nextProps = _objectWithoutPropertiesLoose(props, ["style"]);
        var _this$props = this.props,
          currentStyle = _this$props.style,
          currentProps = _objectWithoutPropertiesLoose(_this$props, ["style"]);
        if (!shallowEqual(currentProps, nextProps) || !shallowEqual(currentStyle, style)) {
          this.attachProps(props);
          return true;
        }
        return false;
      }
    }, {
      key: "render",
      value: function render() {
        var _this15 = this;
        var _this$propsAnimated$g = this.propsAnimated.getValue(),
          scrollTop = _this$propsAnimated$g.scrollTop,
          scrollLeft = _this$propsAnimated$g.scrollLeft,
          animatedProps = _objectWithoutPropertiesLoose(_this$propsAnimated$g, ["scrollTop", "scrollLeft"]);
        return React__default.createElement(Component, _extends({}, animatedProps, {
          ref: function ref(node) {
            return _this15.node = handleRef(node, _this15.props.forwardRef);
          }
        }));
      }
    }]);
    return AnimatedComponent;
  }(React__default.Component);
  return React__default.forwardRef(function (props, ref) {
    return React__default.createElement(AnimatedComponent, _extends({}, props, {
      forwardRef: ref
    }));
  });
}
var config = {
  default: {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
};
var Spring = /*#__PURE__*/function (_React__default$Compo2) {
  _inherits(Spring, _React__default$Compo2);
  function Spring() {
    var _this16;
    _classCallCheck(this, Spring);
    _this16 = _possibleConstructorReturn(this, _getPrototypeOf(Spring).apply(this, arguments));
    _this16.state = {
      lastProps: {
        from: {},
        to: {}
      },
      propsChanged: false,
      internal: false
    };
    _this16.controller = new Controller(null, null);
    _this16.didUpdate = false;
    _this16.didInject = false;
    _this16.finished = true;
    _this16.start = function () {
      _this16.finished = false;
      var wasMounted = _this16.mounted;
      _this16.controller.start(function (props) {
        return _this16.finish(_extends({}, props, {
          wasMounted: wasMounted
        }));
      }, _this16.update);
    };
    _this16.stop = function () {
      return _this16.controller.stop(true);
    };
    _this16.update = function () {
      return _this16.mounted && _this16.setState({
        internal: true
      });
    };
    _this16.finish = function (_ref) {
      var finished = _ref.finished,
        noChange = _ref.noChange,
        wasMounted = _ref.wasMounted;
      _this16.finished = true;
      if (_this16.mounted && finished) {
        // Only call onRest if either we *were* mounted, or when there were changes
        if (_this16.props.onRest && (wasMounted || !noChange)) _this16.props.onRest(_this16.controller.merged); // Restore end-state

        if (_this16.mounted && _this16.didInject) {
          _this16.afterInject = convertValues(_this16.props);
          _this16.setState({
            internal: true
          });
        } // If we have an inject or values to apply after the animation we ping here

        if (_this16.mounted && (_this16.didInject || _this16.props.after)) _this16.setState({
          internal: true
        });
        _this16.didInject = false;
      }
    };
    return _this16;
  }
  _createClass(Spring, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // componentDidUpdate isn't called on mount, we call it here to start animating
      this.componentDidUpdate();
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Stop all ongoing animtions
      this.mounted = false;
      this.stop();
    }
  }, {
    key: "render",
    value: function render() {
      var _this17 = this;
      var children = this.props.children;
      var propsChanged = this.state.propsChanged; // Inject phase -----------------------------------------------------------
      // Handle injected frames, for instance targets/web/fix-auto
      // An inject will return an intermediary React node which measures itself out
      // .. and returns a callback when the values sought after are ready, usually "auto".

      if (this.props.inject && propsChanged && !this.injectProps) {
        var frame = this.props.inject(this.props, function (injectProps) {
          // The inject frame has rendered, now let's update animations...
          _this17.injectProps = injectProps;
          _this17.setState({
            internal: true
          });
        }); // Render out injected frame

        if (frame) return frame;
      } // Update phase -----------------------------------------------------------

      if (this.injectProps || propsChanged) {
        // We can potentially cause setState, but we're inside render, the flag prevents that
        this.didInject = false; // Update animations, this turns from/to props into AnimatedValues
        // An update can occur on injected props, or when own-props have changed.

        if (this.injectProps) {
          this.controller.update(this.injectProps); // didInject is needed, because there will be a 3rd stage, where the original values
          // .. will be restored after the animation is finished. When someone animates towards
          // .. "auto", the end-result should be "auto", not "1999px", which would block nested
          // .. height/width changes.

          this.didInject = true;
        } else if (propsChanged) this.controller.update(this.props); // Flag an update that occured, componentDidUpdate will start the animation later on

        this.didUpdate = true;
        this.afterInject = undefined;
        this.injectProps = undefined;
      } // Render phase -----------------------------------------------------------
      // Render out raw values or AnimatedValues depending on "native"

      var values = _extends({}, this.controller.getValues(), this.afterInject);
      if (this.finished) values = _extends({}, values, this.props.after);
      return Object.keys(values).length ? children(values) : null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // The animation has to start *after* render, since at that point the scene
      // .. graph should be established, so we do it here. Unfortunatelly, non-native
      // .. animations as well as "auto"-injects call forceUpdate, so it's causing a loop.
      // .. didUpdate prevents that as it gets set only on prop changes.
      if (this.didUpdate) this.start();
      this.didUpdate = false;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, _ref2) {
      var internal = _ref2.internal,
        lastProps = _ref2.lastProps;
      // The following is a test against props that could alter the animation
      var from = props.from,
        to = props.to,
        reset = props.reset,
        force = props.force;
      var propsChanged = !shallowEqual(to, lastProps.to) || !shallowEqual(from, lastProps.from) || reset && !internal || force && !internal;
      return {
        propsChanged: propsChanged,
        lastProps: props,
        internal: false
      };
    }
  }]);
  return Spring;
}(React__default.Component);
Spring.defaultProps = {
  from: {},
  to: {},
  config: config.default,
  native: false,
  immediate: false,
  reset: false,
  force: false,
  inject: bugfixes
};
var Trail = /*#__PURE__*/function (_React__default$PureC) {
  _inherits(Trail, _React__default$PureC);
  function Trail() {
    var _this18;
    _classCallCheck(this, Trail);
    _this18 = _possibleConstructorReturn(this, _getPrototypeOf(Trail).apply(this, arguments));
    _this18.first = true;
    _this18.instances = new Set();
    _this18.hook = function (instance, index, length, reverse) {
      // Add instance to set
      _this18.instances.add(instance); // Return undefined on the first index and from then on the previous instance

      if (reverse ? index === length - 1 : index === 0) return undefined;else return Array.from(_this18.instances)[reverse ? index + 1 : index - 1];
    };
    return _this18;
  }
  _createClass(Trail, [{
    key: "render",
    value: function render() {
      var _this19 = this;
      var _this$props = this.props,
        items = _this$props.items,
        _children = _this$props.children,
        _this$props$from = _this$props.from,
        from = _this$props$from === void 0 ? {} : _this$props$from,
        initial = _this$props.initial,
        reverse = _this$props.reverse,
        keys = _this$props.keys,
        delay = _this$props.delay,
        onRest = _this$props.onRest,
        props = _objectWithoutPropertiesLoose(_this$props, ["items", "children", "from", "initial", "reverse", "keys", "delay", "onRest"]);
      var array = toArray(items);
      return toArray(array).map(function (item, i) {
        return React__default.createElement(Spring, _extends({
          onRest: i === 0 ? onRest : null,
          key: typeof keys === 'function' ? keys(item) : toArray(keys)[i],
          from: _this19.first && initial !== void 0 ? initial || {} : from
        }, props, {
          delay: i === 0 && delay || undefined,
          attach: function attach(instance) {
            return _this19.hook(instance, i, array.length, reverse);
          },
          children: function children(props) {
            var child = _children(item, i);
            return child ? child(props) : null;
          }
        }));
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.first = false;
      if (prevProps.items !== this.props.items) this.instances.clear();
    }
  }]);
  return Trail;
}(React__default.PureComponent);
Trail.defaultProps = {
  keys: function keys(item) {
    return item;
  }
};
var DEFAULT = '__default';
var KeyframesImpl = /*#__PURE__*/function (_React__default$PureC2) {
  _inherits(KeyframesImpl, _React__default$PureC2);
  function KeyframesImpl() {
    var _this20;
    _classCallCheck(this, KeyframesImpl);
    var _this;
    _this20 = _possibleConstructorReturn(this, _getPrototypeOf(KeyframesImpl).apply(this, arguments));
    _this = _assertThisInitialized(_assertThisInitialized(_this20));
    _this20.guid = 0;
    _this20.state = {
      props: {},
      resolve: function resolve() {
        return null;
      },
      last: true,
      index: 0
    };
    _this20.next = function (props, last, index) {
      if (last === void 0) {
        last = true;
      }
      if (index === void 0) {
        index = 0;
      }
      _this.running = true;
      return new Promise(function (resolve) {
        _this.mounted && _this.setState(function (state) {
          return {
            props: props,
            resolve: resolve,
            last: last,
            index: index
          };
        }, function () {
          return _this.running = false;
        });
      });
    };
    return _this20;
  }
  _createClass(KeyframesImpl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.componentDidUpdate({});
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previous) {
      var _this21 = this;
      var _this2 = this;
      var _this$props = this.props,
        states = _this$props.states,
        f = _this$props.filter,
        state = _this$props.state;
      if (previous.state !== this.props.state || this.props.reset && !this.running || !shallowEqual(states[state], previous.states[previous.state])) {
        if (states && state && states[state]) {
          var localId = ++this.guid;
          var slots = states[state];
          if (slots) {
            if (Array.isArray(slots)) {
              var q = Promise.resolve();
              var _loop = function _loop() {
                var index = i;
                var slot = slots[index];
                var last = index === slots.length - 1;
                q = q.then(function () {
                  return localId === _this21.guid && _this21.next(f(slot), last, index);
                });
              };
              for (var i = 0; i < slots.length; i++) {
                _loop();
              }
            } else if (typeof slots === 'function') {
              var index = 0;
              slots(
              // next
              function (props, last) {
                if (last === void 0) {
                  last = false;
                }
                return localId === _this2.guid && _this2.next(f(props), last, index++);
              },
              // cancel
              function () {
                return requestFrame(function () {
                  return _this21.instance && _this21.instance.stop();
                });
              },
              // ownprops
              this.props);
            } else {
              this.next(f(states[state]));
            }
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this22 = this;
      var _this$state = this.state,
        props = _this$state.props,
        resolve = _this$state.resolve,
        last = _this$state.last,
        index = _this$state.index;
      if (!props || Object.keys(props).length === 0) return null;
      var _this$props2 = this.props,
        state = _this$props2.state,
        filter = _this$props2.filter,
        states = _this$props2.states,
        config = _this$props2.config,
        Component = _this$props2.primitive,
        _onRest = _this$props2.onRest,
        forwardRef = _this$props2.forwardRef,
        rest = _objectWithoutPropertiesLoose(_this$props2, ["state", "filter", "states", "config", "primitive", "onRest", "forwardRef"]); // Arrayed configs need an index to process

      if (Array.isArray(config)) config = config[index];
      return React__default.createElement(Component, _extends({
        ref: function ref(_ref) {
          return _this22.instance = handleRef(_ref, forwardRef);
        },
        config: config
      }, rest, props, {
        onRest: function onRest(args) {
          resolve(args);
          if (_onRest && last) _onRest(args);
        }
      }));
    }
  }]);
  return KeyframesImpl;
}(React__default.PureComponent);
KeyframesImpl.defaultProps = {
  state: DEFAULT
};
var Keyframes = React__default.forwardRef(function (props, ref) {
  return React__default.createElement(KeyframesImpl, _extends({}, props, {
    forwardRef: ref
  }));
});
Keyframes.create = function (primitive) {
  return function (states, filter) {
    if (filter === void 0) {
      filter = function filter(states) {
        return states;
      };
    }
    if (typeof states === 'function' || Array.isArray(states)) states = _defineProperty({}, DEFAULT, states);
    return function (props) {
      return React__default.createElement(KeyframesImpl, _extends({
        primitive: primitive,
        states: states,
        filter: filter
      }, props));
    };
  };
};
Keyframes.Spring = function (states) {
  return Keyframes.create(Spring)(states, interpolateTo);
};
Keyframes.Trail = function (states) {
  return Keyframes.create(Trail)(states, interpolateTo);
};
var guid = 0;
var get = function get(props) {
  var items = props.items,
    keys = props.keys,
    rest = _objectWithoutPropertiesLoose(props, ["items", "keys"]);
  items = toArray(items !== void 0 ? items : null);
  keys = typeof keys === 'function' ? items.map(keys) : toArray(keys); // Make sure numeric keys are interpreted as Strings (5 !== "5")

  return _extends({
    items: items,
    keys: keys.map(function (key) {
      return String(key);
    })
  }, rest);
};
var Transition = /*#__PURE__*/function (_React__default$PureC3) {
  _inherits(Transition, _React__default$PureC3);
  _createClass(Transition, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }]);
  function Transition(prevProps) {
    var _this23;
    _classCallCheck(this, Transition);
    _this23 = _possibleConstructorReturn(this, _getPrototypeOf(Transition).call(this, prevProps));
    _this23.destroyItem = function (item, key, state) {
      return function (values) {
        var _this$props = _this23.props,
          onRest = _this$props.onRest,
          onDestroyed = _this$props.onDestroyed;
        if (_this23.mounted) {
          onDestroyed && onDestroyed(item);
          _this23.setState(function (_ref) {
            var deleted = _ref.deleted;
            return {
              deleted: deleted.filter(function (t) {
                return t.key !== key;
              })
            };
          });
          onRest && onRest(item, state, values);
        }
      };
    };
    _this23.state = {
      first: true,
      transitions: [],
      current: {},
      deleted: [],
      prevProps: prevProps
    };
    return _this23;
  }
  _createClass(Transition, [{
    key: "render",
    value: function render() {
      var _this24 = this;
      var _this$props2 = this.props,
        initial = _this$props2.initial,
        _this$props2$from = _this$props2.from,
        _this$props2$enter = _this$props2.enter,
        _this$props2$leave = _this$props2.leave,
        _this$props2$update = _this$props2.update,
        onDestroyed = _this$props2.onDestroyed,
        keys = _this$props2.keys,
        items = _this$props2.items,
        onFrame = _this$props2.onFrame,
        onRest = _this$props2.onRest,
        onStart = _this$props2.onStart,
        trail = _this$props2.trail,
        config = _this$props2.config,
        _children = _this$props2.children,
        unique = _this$props2.unique,
        reset = _this$props2.reset,
        extra = _objectWithoutPropertiesLoose(_this$props2, ["initial", "from", "enter", "leave", "update", "onDestroyed", "keys", "items", "onFrame", "onRest", "onStart", "trail", "config", "children", "unique", "reset"]);
      return this.state.transitions.map(function (_ref4, i) {
        var state = _ref4.state,
          key = _ref4.key,
          item = _ref4.item,
          from = _ref4.from,
          to = _ref4.to,
          trail = _ref4.trail,
          config = _ref4.config,
          destroyed = _ref4.destroyed;
        return React__default.createElement(Keyframes, _extends({
          reset: reset && state === 'enter',
          primitive: Spring,
          state: state,
          filter: interpolateTo,
          states: _defineProperty({}, state, to),
          key: key,
          onRest: destroyed ? _this24.destroyItem(item, key, state) : onRest && function (values) {
            return onRest(item, state, values);
          },
          onStart: onStart && function () {
            return onStart(item, state);
          },
          onFrame: onFrame && function (values) {
            return onFrame(item, state, values);
          },
          delay: trail,
          config: config
        }, extra, {
          from: from,
          children: function children(props) {
            var child = _children(item, state, i);
            return child ? child(props) : null;
          }
        }));
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, _ref2) {
      var first = _ref2.first,
        prevProps = _ref2.prevProps,
        state = _objectWithoutPropertiesLoose(_ref2, ["first", "prevProps"]);
      var _get = get(props),
        items = _get.items,
        keys = _get.keys,
        initial = _get.initial,
        from = _get.from,
        enter = _get.enter,
        leave = _get.leave,
        update = _get.update,
        _get$trail = _get.trail,
        trail = _get$trail === void 0 ? 0 : _get$trail,
        unique = _get.unique,
        config = _get.config;
      var _get2 = get(prevProps),
        _keys = _get2.keys,
        _items = _get2.items;
      var current = _extends({}, state.current);
      var deleted = _toConsumableArray(state.deleted); // Compare next keys with current keys

      var currentKeys = Object.keys(current);
      var currentSet = new Set(currentKeys);
      var nextSet = new Set(keys);
      var added = keys.filter(function (item) {
        return !currentSet.has(item);
      });
      var removed = state.transitions.filter(function (item) {
        return !item.destroyed && !nextSet.has(item.originalKey);
      }).map(function (i) {
        return i.originalKey;
      });
      var updated = keys.filter(function (item) {
        return currentSet.has(item);
      });
      var delay = 0;
      added.forEach(function (key) {
        // In unique mode, remove fading out transitions if their key comes in again
        if (unique && deleted.find(function (d) {
          return d.originalKey === key;
        })) deleted = deleted.filter(function (t) {
          return t.originalKey !== key;
        });
        var keyIndex = keys.indexOf(key);
        var item = items[keyIndex];
        var state = 'enter';
        current[key] = {
          state: state,
          originalKey: key,
          key: unique ? String(key) : guid++,
          item: item,
          trail: delay = delay + trail,
          config: callProp(config, item, state),
          from: callProp(first ? initial !== void 0 ? initial || {} : from : from, item),
          to: callProp(enter, item)
        };
      });
      removed.forEach(function (key) {
        var keyIndex = _keys.indexOf(key);
        var item = _items[keyIndex];
        var state = 'leave';
        deleted.push(_extends({}, current[key], {
          state: state,
          destroyed: true,
          left: _keys[Math.max(0, keyIndex - 1)],
          right: _keys[Math.min(_keys.length, keyIndex + 1)],
          trail: delay = delay + trail,
          config: callProp(config, item, state),
          to: callProp(leave, item)
        }));
        delete current[key];
      });
      updated.forEach(function (key) {
        var keyIndex = keys.indexOf(key);
        var item = items[keyIndex];
        var state = 'update';
        current[key] = _extends({}, current[key], {
          item: item,
          state: state,
          trail: delay = delay + trail,
          config: callProp(config, item, state),
          to: callProp(update, item)
        });
      }); // This tries to restore order for deleted items by finding their last known siblings

      var out = keys.map(function (key) {
        return current[key];
      });
      deleted.forEach(function (_ref3) {
        var left = _ref3.left,
          right = _ref3.right,
          transition = _objectWithoutPropertiesLoose(_ref3, ["left", "right"]);
        var pos; // Was it the element on the left, if yes, move there ...

        if ((pos = out.findIndex(function (t) {
          return t.originalKey === left;
        })) !== -1) pos += 1; // Or how about the element on the right ...

        if (pos === -1) pos = out.findIndex(function (t) {
          return t.originalKey === right;
        }); // Maybe we'll find it in the list of deleted items

        if (pos === -1) pos = deleted.findIndex(function (t) {
          return t.originalKey === left;
        }); // Checking right side as well

        if (pos === -1) pos = deleted.findIndex(function (t) {
          return t.originalKey === right;
        }); // And if nothing else helps, move it to the start ¯\_(ツ)_/¯

        pos = Math.max(0, pos);
        out = [].concat(_toConsumableArray(out.slice(0, pos)), [transition], _toConsumableArray(out.slice(pos)));
      });
      return {
        first: first && added.length === 0,
        transitions: out,
        current: current,
        deleted: deleted,
        prevProps: props
      };
    }
  }]);
  return Transition;
}(React__default.PureComponent);
Transition.defaultProps = {
  keys: function keys(item) {
    return item;
  },
  unique: false,
  reset: false
};

// Solution: https://stackoverflow.com/questions/638565/parsing-scientific-notation-sensibly/658662

var stringShapeRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
function createInterpolation(config$$1) {
  var outputRange = config$$1.output;
  var outputRanges = outputRange[0].match(stringShapeRegex).map(function () {
    return [];
  });
  outputRange.forEach(function (value) {
    value.match(stringShapeRegex).forEach(function (number, i) {
      return outputRanges[i].push(+number);
    });
  });
  var interpolations = outputRange[0].match(stringShapeRegex).map(function (_, i) {
    return Interpolation.create(_extends({}, config$$1, {
      output: outputRanges[i]
    }));
  });
  return function (input) {
    var i = 0;
    return outputRange[0].replace(stringShapeRegex, function () {
      return interpolations[i++](input);
    });
  };
} // Render 30/fps by default

injectFrame(function (cb) {
  return setTimeout(cb, 1000 / 30);
}, function (r) {
  return clearTimeout(r);
});
injectInterpolation(createInterpolation);
injectApplyAnimatedValues(function () {
  return false;
}, function (style) {
  return style;
});
exports.Spring = Spring;
exports.Keyframes = Keyframes;
exports.Transition = Transition;
exports.Trail = Trail;
exports.Controller = Controller;
exports.config = config;
exports.animated = createAnimatedComponent;
exports.interpolate = interpolate$1;
exports.Globals = Globals;